"use client";

import { RouteErrorView } from "@/components/error/route-error-view";

export default function PriceIndexError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="min-h-dvh bg-muted">
      <RouteErrorView
        error={error}
        reset={reset}
        variant="card"
        title="Pricing data didn't load"
        navigation={{ label: "Back to price indexes", href: "/price-index" }}
        containerClassName="container mx-auto flex min-h-[70vh] items-center justify-center px-4 py-12"
      />
    </div>
  );
}
